// Module
var code = "<div if=\"description\" html=\"{{ description }}\" class=\"gc-description\"></div>";
// Exports
export default code;